import { render, staticRenderFns } from "./SideNavDeliveryPlanetChicken.vue?vue&type=template&id=9a80a064"
import script from "./SideNavDeliveryPlanetChicken.vue?vue&type=script&lang=js"
export * from "./SideNavDeliveryPlanetChicken.vue?vue&type=script&lang=js"
import style0 from "./SideNavDeliveryPlanetChicken.vue?vue&type=style&index=0&id=9a80a064&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports